import { IAuthState } from "./auth";
export default class AuthSelectors {
  public static didRefreshAuth = (state: IAuthState): boolean =>
    state.didRefresh;

  public static isSignedIn = (state: IAuthState): boolean =>
    Boolean(state.user);

    public static currentUserId = (state: IAuthState) =>
    state.user ? state.user.uid : null;

    public static currentUserEmail = (state: IAuthState) =>
    state.user ? state.user.email : null;

  public static isSendingMagicLink = (state: IAuthState): boolean =>
    Boolean(state.magicLink && state.magicLink.sending);

  public static magicLinkEmail = (state: IAuthState) =>
    state.magicLink && state.magicLink.email;

  public static didFailSendingMagicLink = (state: IAuthState): boolean =>
    Boolean(state.magicLink && state.magicLink.error);

    public static magicLinkSendingFailureError = (state: IAuthState) =>
    state.magicLink ? state.magicLink.error : undefined;

  public static didSendMagicLink = (state: IAuthState): boolean => {
    return Boolean(
      state.magicLink && !state.magicLink.error && !state.magicLink.sending
    );}

  public static didFailSigningInWithMagicLink = (state: IAuthState): boolean =>
    Boolean(state.failedSigninWithMagicLink);

    public static isPendingLead = (state: IAuthState): boolean =>
    Boolean(state.isPeandingLead);
}



// WEBPACK FOOTER //
// ./src/state/modules/auth/AuthSelectors.ts